/**
 * Free Remotion Template Component
 * ---------------------------------
 * This template is free to use in your projects!
 * Credit appreciated but not required.
 *
 * Created by the team at https://www.reactvideoeditor.com
 *
 * Happy coding and building amazing videos! 🎉
 */

"use client";

import { spring, useCurrentFrame, useVideoConfig } from "remotion";

export default function LowerThird() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const accentSlide = spring({
    frame,
    fps,
    from: -300,
    to: 0,
    durationInFrames: 25,
    config: {
      damping: 15,
      mass: 0.6,
    },
  });

  const barSlide = spring({
    frame: Math.max(0, frame - 5),
    fps,
    from: -400,
    to: 0,
    durationInFrames: 30,
    config: {
      damping: 14,
      mass: 0.7,
    },
  });

  const textOpacity = spring({
    frame: Math.max(0, frame - 15),
    fps,
    from: 0,
    to: 1,
    durationInFrames: 20,
  });

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(180deg, #111827 0%, #1f2937 100%)",
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "20%",
          left: 40,
        }}
      >
        <div
          style={{
            width: 200,
            height: 3,
            background: "linear-gradient(90deg, #3b82f6, #4361ee)",
            transform: `translateX(${accentSlide}px)`,
            borderRadius: 2,
            marginBottom: 4,
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            transform: `translateX(${barSlide}px)`,
          }}
        >
          <div
            style={{
              width: 4,
              background: "#3b82f6",
              borderRadius: "2px 0 0 2px",
            }}
          />
          <div
            style={{
              background: "rgba(0, 0, 0, 0.7)",
              padding: "16px 32px",
              borderRadius: "0 4px 4px 0",
            }}
          >
            <div
              style={{
                color: "white",
                fontSize: "1.6rem",
                fontWeight: "bold",
                opacity: textOpacity,
                letterSpacing: "0.02em",
              }}
            >
              John Smith
            </div>
            <div
              style={{
                color: "rgba(255, 255, 255, 0.7)",
                fontSize: "1rem",
                fontWeight: 300,
                opacity: textOpacity,
                marginTop: 4,
                letterSpacing: "0.05em",
              }}
            >
              Senior Producer
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
